import yup from 'schemas/validation/feature'
import outputSchema from './outputSchema'

const outputMapSchema = yup.object({
  outputQuery: yup
    .string()
    .nullable()
    .when('$isOneOutputQueryDefined', (isOneOutputQueryDefined, schema) =>
      isOneOutputQueryDefined === false
        ? yup.string().required().nullable()
        : schema
    ),
  outputs: yup.array().of(outputSchema),
})

export default outputMapSchema
